<template>
  <div
    class="onboarding-overlay"
    :class="{ 'onboarding-overlay--dark': !rect }"
    @click.self="null"
  >
    <div v-if="rect" class="onboarding-highlight" :style="highlightStyle"></div>
    <div class="onboarding-bubble" :style="bubbleStyle">
      <p class="onboarding-text">{{ currentStep.text }}</p>
      <div class="onboarding-actions">
        <SecondaryButton text="Überspringen" @click="finish" />
        <PrimaryButton :text="isLast ? 'Fertig' : 'Weiter'" @click="next" />
      </div>
    </div>
  </div>
</template>

<script>
import steps from "@/modules/onboardingSteps";
import PrimaryButton from "@/components/elements/PrimaryButton.vue";
import SecondaryButton from "@/components/elements/SecondaryButton.vue";

export default {
  components: { PrimaryButton, SecondaryButton },
  emits: ["finish"],
  data() {
    return { steps, stepIndex: 0, rect: null };
  },
  computed: {
    currentStep() { return this.steps[this.stepIndex]; },
    isLast() { return this.stepIndex === this.steps.length - 1; },
    highlightStyle() {
      if (!this.rect) return {};
      const r = this.rect;
      return {
        top: r.top + "px",
        left: r.left + "px",
        width: r.width + "px",
        height: r.height + "px",
      };
    },
    bubbleStyle() {
      if (!this.rect) {
        return { top: "50%", left: "50%", transform: "translate(-50%, -50%)" };
      }
      const r = this.rect;
      // Sprechblase rechts neben dem Highlight (Sidebar ist links).
      // Auf schmalen Viewports clampen, damit die Blase (max 320px + 16px Rand)
      // nicht aus dem Sichtbereich ragt.
      const BUBBLE_W = 320, MARGIN = 16;
      const preferred = r.left + r.width + MARGIN;
      const maxLeft = Math.max(MARGIN, window.innerWidth - BUBBLE_W - MARGIN);
      const left = Math.min(preferred, maxLeft);
      const maxTop = Math.max(MARGIN, window.innerHeight - MARGIN - 160);
      const top = Math.min(r.top, maxTop);
      return { top: top + "px", left: left + "px" };
    },
  },
  mounted() {
    this.reposition();
    window.addEventListener("resize", this.reposition);
    window.addEventListener("scroll", this.reposition, true);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.reposition);
    window.removeEventListener("scroll", this.reposition, true);
  },
  methods: {
    reposition() {
      const sel = this.currentStep.selector;
      if (!sel) { this.rect = null; return; }
      const el = document.querySelector(sel);
      this.rect = el ? el.getBoundingClientRect() : null;
    },
    next() {
      if (this.stepIndex < this.steps.length - 1) {
        this.stepIndex++;
        this.reposition();
      } else {
        this.finish();
      }
    },
    finish() { this.$emit("finish"); },
  },
};
</script>

<style scoped>
/*
  Spotlight-Variante:
  - overlay ist standardmäßig transparent (kein eigener Hintergrund)
  - wenn rect vorhanden: .onboarding-highlight erzeugt den dunklen Effekt
    via box-shadow: 0 0 0 9999px rgba(0,0,0,0.5) — alles außer dem Highlight
    wird abgedunkelt, das Overlay selbst bleibt transparent (kein Doppel-Dunkel)
  - wenn rect null (Willkommen-Schritt, kein Anker): .onboarding-overlay--dark
    setzt einen dunklen Hintergrund direkt aufs Overlay, da kein box-shadow greift
*/
.onboarding-overlay {
  position: fixed;
  inset: 0;
  background: transparent;
  z-index: 9999;
}

.onboarding-overlay--dark {
  background: rgba(0, 0, 0, 0.5);
}

.onboarding-highlight {
  position: fixed;
  border: 3px solid var(--ink);
  border-radius: 6px;
  /* Spotlight-Effekt: alles außer diesem Element wird abgedunkelt */
  box-shadow: 0 0 0 9999px rgba(0, 0, 0, 0.5);
  z-index: 10000;
  pointer-events: none;
  transition: all 0.2s;
}

.onboarding-bubble {
  position: fixed;
  max-width: 320px;
  background: #fff;
  color: #222;
  border-radius: 8px;
  padding: 16px;
  z-index: 10001;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3);
}

.onboarding-text {
  margin: 0 0 12px;
}

.onboarding-actions {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
}
</style>
